import React from 'react';
import { Paper, Box, Typography, Button, Chip } from '@mui/material';
import { ArrowForward as ArrowForwardIcon } from '@mui/icons-material';

interface WidgetCardProps {
  title: string;
  icon?: React.ReactNode;
  comingSoon?: boolean;
  actionLabel?: string;
  onAction?: () => void;
  children: React.ReactNode;
  testId?: string;
}

const WidgetCard: React.FC<WidgetCardProps> = ({
  title,
  icon,
  comingSoon = false,
  actionLabel,
  onAction,
  children,
  testId,
}) => {
  return (
    <Paper
      variant="outlined"
      sx={{
        p: 2.5,
        borderRadius: 2,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        opacity: comingSoon ? 0.7 : 1,
      }}
      data-testid={testId}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
        {icon && <Box sx={{ mr: 1, color: 'primary.main', display: 'flex' }}>{icon}</Box>}
        <Typography variant="subtitle2" fontWeight={700} sx={{ flex: 1 }}>
          {title}
        </Typography>
        {comingSoon && <Chip label="곧 출시" size="small" variant="outlined" />}
      </Box>
      <Box sx={{ flex: 1, minHeight: 0 }}>{children}</Box>
      {actionLabel && onAction && (
        <Box sx={{ mt: 1.5, display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            size="small"
            endIcon={<ArrowForwardIcon fontSize="inherit" />}
            onClick={onAction}
            disabled={comingSoon}
          >
            {actionLabel}
          </Button>
        </Box>
      )}
    </Paper>
  );
};

export default WidgetCard;
